export class IngredientDetector {
    static isIngredientList(text) {
        const minLengthForIngredients = 20;
        const commonSeparatorsRegex = /,|;|･|•|●|·|\. (?![^)]*\))(?!\d)/;

        const isLongEnough = text.length >= minLengthForIngredients;
        const separatorMatches = text.match(new RegExp(commonSeparatorsRegex, 'g'));
        const hasSeparators = this.hasRepeatedSeparator(separatorMatches, 4);

        return isLongEnough && hasSeparators;
    }

    static submitForAnalysis(ingredientsText) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/analysis';
        form.style.display = 'none';

        const csrfToken = this.getCsrfToken();
        if (csrfToken) {
            const csrfInput = document.createElement('input');
            csrfInput.type = 'hidden';
            csrfInput.name = this.getCsrfParam();
            csrfInput.value = csrfToken;
            form.appendChild(csrfInput);
        }

        const ingredientsInput = document.createElement('input');
        ingredientsInput.type = 'hidden';
        ingredientsInput.name = 'analysis[ingredients]';
        ingredientsInput.value = ingredientsText;
        form.appendChild(ingredientsInput);

        const analysisTypeInput = document.createElement('input');
        analysisTypeInput.type = 'hidden';
        analysisTypeInput.name = 'analysis[analysis_type]';
        analysisTypeInput.value = 'standard';
        form.appendChild(analysisTypeInput);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    static getCsrfToken() {
        const metaTag = document.querySelector('meta[name="csrf-token"]');
        return metaTag ? metaTag.getAttribute('content') : null;
    }

    static getCsrfParam() {
        const metaTag = document.querySelector('meta[name="csrf-param"]');
        return metaTag ? metaTag.getAttribute('content') : 'authenticity_token';
    }

    static hasRepeatedSeparator(matches, minCount) {
        if (!matches) return false;

        const counts = {};
        for (const sep of matches) {
            counts[sep] = (counts[sep] || 0) + 1;
            if (counts[sep] > minCount) return true;
        }
        return false;
    }
}
